"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@angular-redux/store");
var toast_service_1 = require("../../service/toast.service");
var datePickerOptions = require("../../../core/date-picker-options");
var TxFilterComponent = /** @class */ (function () {
    function TxFilterComponent(_ngRedux, _toastService) {
        this._ngRedux = _ngRedux;
        this._toastService = _toastService;
        this.inputType = 'text';
        this.dateActions = new core_1.EventEmitter();
        this.datePickerFormat = datePickerOptions.minDatePicker;
        this.txOnFilterApply = new core_1.EventEmitter();
    }
    TxFilterComponent.prototype.ngOnInit = function () {
    };
    TxFilterComponent.prototype.ngOnChanges = function () {
        this.updateCurrentFilterValue();
    };
    TxFilterComponent.prototype.updateCurrentFilterValue = function () {
        var _this = this;
        this._ngRedux.select(this.filterField)
            .subscribe(function (value) { return _this.typedValue = value; });
    };
    TxFilterComponent.prototype.toggleDatePicker = function () {
        this.dateActions.emit({ action: 'pickadate', params: ['open'] });
    };
    TxFilterComponent.prototype.applyFilter = function () {
        if (this.inputType !== 'toggle') {
            this.applyTypedValue();
        }
        else {
            this.applyToggleValue();
        }
    };
    TxFilterComponent.prototype.cleanFilter = function () {
        var _this = this;
        this._ngRedux.select([this.filterField[0]])
            .subscribe(function (filter) {
            _this.filter = filter;
            _this.typedValue = undefined;
            _this.updateFieldValue();
        });
    };
    TxFilterComponent.prototype.applyMask = function (event) {
        if (this.mask) {
            this.typedValue = this.mask.transform(event.target.value, event.key);
        }
        else {
            this.typedValue = event.target.value;
        }
    };
    TxFilterComponent.prototype.getObjectKeys = function (object) {
        if (object) {
            return Object.keys(object);
        }
        return [];
    };
    TxFilterComponent.prototype.applyTypedValue = function () {
        var _this = this;
        if (this.typedValue) {
            this._ngRedux.select([this.filterField[0]])
                .subscribe(function (filter) {
                _this.filter = filter;
                _this.updateFieldValue();
            });
        }
        else {
            this.showMessage('Informe um valor para o filtro!');
        }
    };
    TxFilterComponent.prototype.applyToggleValue = function () {
        var _this = this;
        if (!this.typedValue) {
            this.typedValue = false;
        }
        this._ngRedux.select([this.filterField[0]])
            .subscribe(function (filter) {
            _this.filter = filter;
            _this.updateFieldValue();
        });
    };
    TxFilterComponent.prototype.updateFieldValue = function () {
        var fields = this.getFilterFields();
        var target = this.filter;
        var index = 0;
        // accessing correct field to update
        for (; index < fields.length - 1; index++) {
            target = target[fields[index]];
        }
        target[fields[index]] = this.typedValue;
        this.dispatchEvents();
    };
    TxFilterComponent.prototype.dispatchEvents = function () {
        this._ngRedux.dispatch({ type: this.actionType, body: { filter: this.filter } });
        this.txOnFilterApply.emit();
    };
    TxFilterComponent.prototype.getFilterFields = function () {
        return this.filterField.slice(1, this.filterField.length);
    };
    TxFilterComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    TxFilterComponent.ctorParameters = function () { return [{ type: store_1.NgRedux }, { type: toast_service_1.ToastService }]; };
    return TxFilterComponent;
}());
exports.TxFilterComponent = TxFilterComponent;
//# sourceMappingURL=tx-filter.component.js.map


// WEBPACK FOOTER //
// tx-filter.component.js